export default __webpack_public_path__ + "static/media/icon-logo.9ed204a8.svg";